import type { CustomerBadgeTone } from '@/components/customer-portal/CustomerStatusBadge';
import type { CustomerAuthorizationStatusLabel } from '@/types/customer-authorization.types';

/**
 * Single source of truth for Authorization Case status → badge tone, shared
 * by CustomerJobDetailPage's case list and CustomerAuthorizationCaseDetail
 * (previously two duplicated local STATUS_BADGE maps with raw hex values).
 * Declined uses `danger` per this session's explicit instruction.
 */
export const AUTHORIZATION_STATUS_TONE: Record<
  CustomerAuthorizationStatusLabel,
  CustomerBadgeTone
> = {
  'Awaiting Your Response': 'warning',
  'Under Review': 'info',
  Approved: 'success',
  Declined: 'danger',
  Expired: 'neutral',
  'Status Unavailable': 'neutral',
};
